export default __webpack_public_path__ + "static/media/hht1_storybook_18.16c7bfb8.png";